import { $apiAllo } from '@/services/api-allo/client';
import { keepPreviousData } from '@tanstack/react-query';

interface UseContactsQueryOptions {
  enabled?: boolean;
}

/**
 * Hook to fetch contacts with infinite scroll pagination.
 * Sorted by last activity date descending.
 */
export function useContactsQuery({ enabled = true }: UseContactsQueryOptions = {}) {
  return $apiAllo.useInfiniteQuery(
    'get',
    '/v1/contact',
    {
      params: {
        query: {
          'page[size]': 50,
          'sort_by[last_activity]': 'desc',
          extend: 'custom_properties' as const,
        },
      },
    },
    {
      initialPageParam: 0,
      getNextPageParam: (lastPage?: {
        metadata?: {
          pagination?: { current_page?: number; total_pages?: number };
        };
      }) => {
        const currentPage = lastPage?.metadata?.pagination?.current_page ?? 0;
        const totalPages = lastPage?.metadata?.pagination?.total_pages ?? 0;
        return currentPage < totalPages - 1 ? currentPage + 1 : undefined;
      },
      pageParamName: 'page[number]',
      placeholderData: keepPreviousData,
      staleTime: 1000 * 10,
      enabled,
    },
  );
}
